import { render, staticRenderFns } from "./CjNewsDetail.vue?vue&type=template&id=9de3aec0&"
import script from "./CjNewsDetail.vue?vue&type=script&lang=js&"
export * from "./CjNewsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports